import { Assert } from "@seriously-rad/seriouslyrad-framework-core/Assert";
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { CreateDocumentDialog } from "../Ui/Dialogs/CreateDocumentDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandEntityFileCreateDocumentPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandEntityFileCreateDocumentProperties = {
    [name in keyof EntityCommandEntityFileCreateDocumentPropertyValues]: Property<EntityCommandEntityFileCreateDocumentPropertyValues[name]>
};

export interface IEntityCommandEntityFileCreateDocument extends IEntityCommand, EntityCommandEntityFileCreateDocumentProperties
{
}

export class EntityCommandEntityFileCreateDocument extends EntityCommand implements IEntityCommandEntityFileCreateDocument
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandEntityFileCreateDocument";
    public static override className = "EntityCommandEntityFileCreateDocument";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandEntityFileCreateDocumentPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Create Document",
                entityName: "EntityFile",
                key: "CREATE_DOCUMENT",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected createDocumentDialog?: CreateDocumentDialog;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandEntityFileCreateDocumentPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            parentEntityName = entityCommandInformation.parentEntityName.get(),
            parentEntityId = entityCommandInformation.parentEntityId.get();

        if (!parentEntityName)
            return;

        if (!parentEntityId)
            return;

        if (!this.createDocumentDialog)
            this.createDocumentDialog = new CreateDocumentDialog();

        const
            result = await this.createDocumentDialog.openAsync(parentEntityName);

        if (result.dialogResult !== DialogResultEnum.ok)
            return;

        Assert.isNotNullOrUndefined(this.createDocumentDialog, "self.createDocumentDialog");
        Assert.isNotNullOrUndefined(this.createDocumentDialog.propertyEditorCombo, "self.createDocumentDialog.propertyEditorCombo");

        await
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest("DataService", "CallDataService", { id: "8d5b971f-d1ec-42b2-9cdc-5b7e15bd6ab9", operation: "CreateDocument", data: ObjectHelper.toJson({ entityName: parentEntityName, documentTemplateId: this.createDocumentDialog.propertyEditorCombo.value.get(), recordId: parentEntityId }) })
                .executeAsync();
    }

    // #endregion

    // #endregion
}

